import React from 'react';
import _ from 'lodash';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';

export const BrandMappingStoriesInfoComponent = ({
  brandMappings, 
  onFormItemBrandChange, 
}: any) => {
 
  return (
    <>
      {_.map(brandMappings, (selectedBrand: any, index: any) => (
        <AccordionContainer
          child={
               
 <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
    <div className='col-span-full'>
              <InputContainer
                label="Short Description"
                labelField="ShortDescription"
                onValueChange={(event: any, newValue: any) => {
                  onFormItemBrandChange({
                    value: event,
                    field: 'ShortDescription',
                    idx: index
                  });
                }}
                type="rte"
                value={selectedBrand?.ShortDescription} /></div>
                 <div className='col-span-full'>
                   <InputContainer
                label="Long Description"
                labelField="LongDescription"
                onValueChange={(event: any, newValue: any) => {
                  onFormItemBrandChange({
                    value: event,
                    field: 'LongDescription',
                    idx: index
                  });
                }}
                type="rte"
                value={selectedBrand?.LongDescription} /></div>
 <InputContainer
                label="Search Engine Friendly PageName"
                labelField="SearchEngineFriendlyPageName"
                onValueChange={(event: any, newValue: any) => {
                  onFormItemBrandChange({
                    value: event.target.value,
                    field: 'SearchEngineFriendlyPageName',
                    idx: index
                  });
                }}
                type="text"
                value={selectedBrand?.SearchEngineFriendlyPageName} />
                 <InputContainer
                label="Meta Description"
                labelField="MetaDescription"
                onValueChange={(event: any, newValue: any) => {
                  onFormItemBrandChange({
                    value: event.target.value,
                    field: 'MetaDescription',
                    idx: index
                  });
                }}
                type="text"
                value={selectedBrand?.MetaDescription} />
                 <InputContainer
                label="Meta Keywords"
                labelField="MetaKeywords"
                onValueChange={(event: any, newValue: any) => {
                  onFormItemBrandChange({
                    value: event.target.value,
                    field: 'MetaKeywords',
                    idx: index
                  });
                }}
                type="text"
                value={selectedBrand?.MetaKeywords} />
                 <InputContainer
                label="Meta Title"
                labelField="MetaTitle"
                onValueChange={(event: any, newValue: any) => {
                  onFormItemBrandChange({
                    value: event.target.value,
                    field: 'MetaTitle',
                    idx: index
                  });
                }}
                type="text"
                value={selectedBrand?.MetaTitle} />
                </div>
             
 }
                  expandedPanel="Brand Stories"
                  headerTitle="Brand Stories"
                />
         
      ))}
  </>
  )
}

export default BrandMappingStoriesInfoComponent;
